import { makeStyles, tokens } from '@fluentui/react-components';

export const useGenericIconStyles = makeStyles({
    rootSuccess: {
        fill: tokens.colorStatusSuccessBackground3,
        color: tokens.colorStatusSuccessBackground3,
    },
    rootDanger: {
        fill: tokens.colorStatusDangerBackground3,
        color: tokens.colorStatusDangerBackground3,
    },
    rootWarning: {
        fill: tokens.colorStatusWarningBackground3,
        color: tokens.colorStatusWarningBackground3,
    },
    interactive: {
        '&:active,&:hover': {
            fill: tokens.colorNeutralForeground2BrandHover,
            color: tokens.colorNeutralForeground2BrandHover,
        },
    },
});
